export var EventType;
(function (EventType) {
    EventType["ERROR"] = "ERROR";
    EventType["CLOSE"] = "CLOSE";
    EventType["AUTH_COMPLETE"] = "AUTH_COMPLETE";
    EventType["OPEN"] = "OPEN";
    EventType["SEARCH_ISSUER"] = "SEARCH_ISSUER";
    EventType["SELECT_ISSUER"] = "SELECT_ISSUER";
    EventType["SUBMIT_CREDENTIALS"] = "SUBMIT_CREDENTIALS";
    EventType["SUBMIT_MFA"] = "SUBMIT_MFA";
    EventType["TRANSITION_VIEW"] = "TRANSITION_VIEW";
    EventType["APPLICATION_COMPLETE"] = "APPLICATION_COMPLETE";
    EventType["LOAD_OFFERS"] = "LOAD_OFFERS";
    EventType["CLICK_OFFER"] = "CLICK_OFFER";
    EventType["PROVIDE_CONSENT"] = "PROVIDE_CONSENT";
    EventType["IDENTIFY_PARTNER"] = "IDENTIFY_PARTNER";
})(EventType || (EventType = {}));
